
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-width":"30","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10"}},[_c('circle',{attrs:{"cx":"255.996","cy":"448.8","r":"48.2","data-original":"#000000"}}),_c('path',{attrs:{"d":"M227.743 312.595c2.402 13.729 14.323 23.739 28.253 23.739h.008c13.93 0 25.843-10.009 28.245-23.739 7.961-45.477 25.682-146.737 38.238-218.482a67.486 67.486 0 00-14.805-55.045A67.485 67.485 0 00256.02 15h-.04a67.485 67.485 0 00-51.662 24.068 67.482 67.482 0 00-14.805 55.045c12.555 71.745 30.277 173.005 38.23 218.482z","data-original":"#000000"}})])])
          )
        }
      }
    